import posthog from "posthog-js";

let isInitialized = false;

export function initPostHog() {
  if (isInitialized) {
    return posthog;
  }

  const apiKey = import.meta.env.VITE_POSTHOG_API_KEY;
  const apiHost = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

  if (apiKey && !apiKey.includes("placeholder")) {
    posthog.init(apiKey, {
      api_host: apiHost,
      person_profiles: "identified_only",
      loaded: () => {
        if (import.meta.env.DEV) {
          console.log("[PostHog] Initialized");
        }
      },
    });
    isInitialized = true;
  } else {
    if (import.meta.env.DEV) {
      console.log("[PostHog] Not configured, running in dev mode");
    }
  }

  return posthog;
}

export function getPostHogClient() {
  if (!isInitialized) {
    initPostHog();
  }
  return posthog;
}
